import Pages from '../../../config/Pages';
import { Route } from '../../../core/utils/RouteMixins';
import Listar from './AnaliseNegocial';
import Form from './AnaliseNegocialForm';
import { permissionEnums } from '../../../core/enums/PermissionEnums';

const analiseNegocialRoutes = [
    Route(['Análise Negocial', 'pi pi-map'], Pages.sei.analiseNegocial.url.list, Listar, [
        permissionEnums.ANALISE_NEGOCIAL_VISUALIZAR,
    ]),
    Route(null, Pages.sei.analiseNegocial.url.edit, Form, [
        permissionEnums.ANALISE_NEGOCIAL_EDITAR,
    ]),
];

export default analiseNegocialRoutes;
